module.exports = __webpack_public_path__ + "img/notif-in-app-message.0443d4fa.svg";